module.exports = __webpack_public_path__ + "img/13.68dc4346.jpg";